import type {
	RecentlyUpdatedMacroParams,
	Theme,
	UpdateGroup,
	UpdateItem,
} from './recently-updated-types.ts';

export function resolveTheme(params: RecentlyUpdatedMacroParams): Theme {
	if (params.theme === 'social' || params.showProfilePic) return 'social';
	if (params.theme === 'sidebar') return 'sidebar';
	return 'concise';
}

export function groupByAuthor(items: UpdateItem[]): UpdateGroup[] {
	const groups: UpdateGroup[] = [];
	for (const item of items) {
		const last = groups[groups.length - 1];
		if (last && last.author.username === item.author.username) {
			last.items.push(item);
		} else {
			groups.push({ author: item.author, items: [item] });
		}
	}
	return groups;
}

export function filterByContentType(items: UpdateItem[], contentType: string): UpdateItem[] {
	if (!contentType) return items;
	return items.filter((item) => item.contentType === contentType);
}
